import { render, staticRenderFns } from "./ConfirmArchiveModal.vue?vue&type=template&id=1d8156c5&scoped=true&"
import script from "./ConfirmArchiveModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmArchiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8156c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
